import { Mail, Phone, Instagram } from "lucide-react";
import { NAV_LINKS } from "@/data/index";

// @section: footer
export default function Footer() {
  const scrollTo = (href: string) => {
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer style={{ backgroundColor: "#b3ebf2", color: "#1e2d4e" }}>
      {/* @section: footer-main */}
      <div className="container mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Brand */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <img
                src="/images/logo.jpg"
                alt="Logo Proyecto Nebrija"
                className="h-10 w-10 rounded-full object-contain bg-white p-0.5"
              />
              <span
                className="text-lg font-bold"
                style={{ fontFamily: "'Playfair Display', serif", color: "#1e2d4e" }}
              >
                Proyecto Nebrija
              </span>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: "rgba(30,45,78,0.7)" }}>
              Formación y recursos para docentes de Lengua Castellana y Literatura.
              Materiales gratuitos, cursos en directo y grabados.
            </p>
            <div className="flex gap-3 mt-2">
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full transition-colors duration-200"
                style={{ backgroundColor: "rgba(201,151,42,0.18)", color: "#c9972a" }}
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4
              className="text-sm font-semibold mb-4 uppercase tracking-widest"
              style={{ color: "#c9972a" }}
            >
              Navegación
            </h4>
            <nav className="flex flex-col gap-2">
              {NAV_LINKS.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollTo(link.href)}
                  className="text-sm text-left w-fit transition-colors duration-200 hover:underline underline-offset-2"
                  style={{ color: "rgba(30,45,78,0.75)" }}
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-sm font-semibold mb-4 uppercase tracking-widest"
              style={{ color: "#c9972a" }}
            >
              Contacto
            </h4>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:info@proyectonebrija.es"
                className="flex items-center gap-2 text-sm transition-colors duration-200 hover:underline"
                style={{ color: "rgba(30,45,78,0.75)" }}
              >
                <Mail size={15} />
                info@proyectonebrija.es
              </a>
              <a
                href="tel:+34600000000"
                className="flex items-center gap-2 text-sm"
                style={{ color: "rgba(30,45,78,0.75)" }}
              >
                <Phone size={15} />
                (+34) 600 000 000
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* @section: footer-legal */}
      <div
        className="border-t"
        style={{ borderColor: "rgba(30,45,78,0.15)" }}
      >
        <div className="container mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs" style={{ color: "rgba(30,45,78,0.5)" }}>
            © {new Date().getFullYear()} Proyecto Nebrija · Todos los derechos reservados
          </p>
          <div className="flex gap-5">
            {["Política de privacidad", "Política de cookies", "Aviso legal", "Términos y condiciones"].map((item) => (
              <a
                key={item}
                href="#"
                className="text-xs transition-colors duration-200 hover:underline"
                style={{ color: "rgba(30,45,78,0.5)" }}
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
